import { Component, inject } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators, ɵValue} from '@angular/forms';
import {NgFor} from '@angular/common';
import { UserService } from '../services/user.service';
import { AcctCreateService } from '../services/acct-create.service';
import { Router, RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import firebase from 'firebase/compat/app';
import 'firebase/firestore';
import { getAuth, isSignInWithEmailLink } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';

@Component({
  selector: 'app-teacher-register',
  standalone: true,
  templateUrl: './teacher-register.component.html',
  imports: [ReactiveFormsModule, RouterModule, NgFor],
  styleUrls: [
    './teacher-register.component.css',
    '../app.component.css'
  ]
})

export class TeacherRegisterComponent {
  constructor(private router: Router){};
  route: ActivatedRoute= inject(ActivatedRoute)
  schools : any [] = [];
  ngOnInit() {
    this.getSchools();
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (isSignInWithEmailLink(auth, window.location.href)) {
        const loading = document.querySelector("#loadingMsg");
        loading?.classList.toggle("hidden");
        const loginForm = document.querySelector("#signUpForm");
        loginForm?.classList.toggle("hidden");
      } else {
        this.router.navigate(['/landing']);
      }
    });

    this.createForm.get('role')?.valueChanges.subscribe(role => {
      const schoolControl = this.createForm.get('school');
      const gradeControl = this.createForm.get('grade');

      if(role === 'Teacher' || role == 'GHS Teacher Representative'){
        schoolControl?.setValidators([Validators.required]);
        gradeControl?.setValidators([Validators.required]);
      } else {
        schoolControl?.clearValidators();
        gradeControl?.clearValidators();
      }
      schoolControl?.updateValueAndValidity();
      gradeControl?.updateValueAndValidity();
    })
  }
  async getSchools(){
    const snapshot = await firebase.firestore().collection('school').get();
    snapshot.forEach((doc) => this.schools.push((doc.data())));
    this.schools.sort((a, b) => a.name.localeCompare(b.name))
  }
  userService = inject(UserService);
  acctService = inject(AcctCreateService);
  createForm = new FormGroup({
    title: new FormControl(''),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    role: new FormControl('', Validators.required),
    middleInit: new FormControl(''),
    grade: new FormControl(''),
    school: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', Validators.required),
    passCOnf: new FormControl('', Validators.required),
  })
  submitAcct(){
    if(this.createForm.invalid){
      if(this.createForm.controls['firstName'].hasError('required')){
        alert('Please enter your first name.')
        return;
      }

      if(this.createForm.controls['lastName'].hasError('required')){
        alert('Please enter your last name.')
        return;
      }

      if(this.createForm.controls['role'].hasError('required')){
        alert('Please select your role.')
        return;
      }

      if(this.createForm.controls['grade'].hasError('required')){
        alert('Please select a grade.')
        return;
      }

      if(this.createForm.controls['school'].hasError('required')){
        alert('Please select a school.')
        return;
      }

      if(this.createForm.controls['email'].hasError('required')){
        alert('Email is required.')
        return;
      } else if(this.createForm.controls['email'].hasError('email')){
        alert('Please enter a valid email.')
        return;
      }

      if(this.createForm.controls['password'].hasError('required')){
        alert('Please enter a password.')
        return;
      }
    }

    if(!(this.checkPassword(this.createForm.value.password, this.createForm.value.passCOnf))){
      alert('Please enter the same password.')
      return;
    }

    this.acctService.submitAcct(
      this.createForm.value.title ?? '',
      this.createForm.value.lastName ?? '',
      this.createForm.value.firstName ?? '',
      this.createForm.value.role ?? '',
      this.createForm.value.middleInit ?? '',
      this.createForm.value.grade ?? null,
      this.createForm.value.school ?? null,
      this.createForm.value.email ?? '',
      this.createForm.value.password ?? '',
      this.createForm.value.passCOnf ?? '',
    ).then(() => {
      this.router.navigate(['/profile']); // navigate to profile after account creation
    })
  }

  // check if password and password confirmation match
  checkPassword(password: string | null | undefined, passCOnf: string | null | undefined): boolean {
    return (password ?? '') === (passCOnf ?? '');
  }
}
